import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteAthletePackageHold(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteAthletePackageHold = (athletePackageHoldId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`athlete-package-holds/${athletePackageHoldId}/`);
  };

  return useMutation(deleteAthletePackageHold, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['athletePackages'],
      });
      queryClient.invalidateQueries({
        queryKey: ['invoices'],
      });
      queryClient.invalidateQueries({
        queryKey: ['athleteEvents'],
      });
    },
  });
}
